/* Rquiere de mixin.js */

var trackingsShipping = {
	data () {
		return {
			listTrackingsShipping: [],
			methodsTrackingShipping: {
				get: 'trackingsShipping',
			},
			paginationTrackingsShipping: [],
			searchTrackingsShipping: '',
            searchingTrackingsShipping: false,
		}
	},
	methods:{
		getAllTrackingsShipping(page = 1) {
			this.searchingTrackingsShipping = true
			let parameters = '?search=' + this.searchTrackingsShipping + '&page=' + page
			this.axiosActionIS(this.getApiBackend + this.methodsTrackingShipping.get + parameters, 'GET', 'getAllTrackingsShippingResult')
        },
		getAllTrackingsShippingResult(response) {
			this.searchingTrackingsShipping = false
            if(response.data.success) {
                this.listTrackingsShipping = response.data.data
                this.paginationTrackingsShipping = response.data.paginate    
            }
            this.getAllTrackingsShippingResultLocal(response)
		},
        getAllTrackingsShippingResultLocal(response) {
            console.log('getAllTrackingsShippingResultLocal no desarrollado', response)
        },
	},
};

export default trackingsShipping;